import { useOutletContext } from "react-router-dom"

import type { Tower } from "types/towers.types"

import { BodyContainer } from "widgets/styled/containers"
import TowerDashboard from "widgets/towers/TowerDashboard"
import TowerPosition from "widgets/towers/TowerPosition/TowerPosition"
import { towerTabPlotDefs, legacyTowerInfoTabPlotDefs } from "helpers/config/dashboards"
import { isTowerHealthEnabled } from "helpers/utils/towerHealth"

const TowerInfo = () => {
  const { tower, towerFetching, id } = useOutletContext<{
    tower: Tower
    towerFetching: boolean
    id: string
  }>()

  const towerHealthEnabled = isTowerHealthEnabled(tower)

  const config = towerHealthEnabled
    ? {
        type: "towerTab",
        plotDefs: towerTabPlotDefs,
      }
    : {
        type: "legacyTowerInfoTab",
        plotDefs: legacyTowerInfoTabPlotDefs,
      }

  return (
    <BodyContainer disableGutters maxWidth="xl">
      <TowerDashboard tower={tower} towerFetching={towerFetching} config={config}>
        {towerHealthEnabled && (
          <TowerPosition towerIds={[Number(id)]} towerType={tower.type} />
        )}
      </TowerDashboard>
    </BodyContainer>
  )
}

export default TowerInfo
